module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('confirm', {
    attrs: {
      "value": _vm.show2,
      "title": "登录",
      "close-on-confirm": false
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm
    }
  }, [_c('group', [_c('x-input', {
    attrs: {
      "max": 11,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机号",
      "placeholder": "请输入手机号码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhone
    },
    model: {
      value: (_vm.holderPhone),
      callback: function($$v) {
        _vm.holderPhone = $$v
      },
      expression: "holderPhone"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 4,
      "keyboard": "number",
      "show-clear": false,
      "title": "验证码",
      "placeholder": "请输入手机验证码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhoneCAPTCHA
    },
    model: {
      value: (_vm.holderPhoneCAPTCHA),
      callback: function($$v) {
        _vm.holderPhoneCAPTCHA = $$v
      },
      expression: "holderPhoneCAPTCHA"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCAPTCHA($event)
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687cfba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 678
// module chunks = 1